module.exports = __webpack_public_path__ + "media/images/icons/outlined/down-beed19231d6591845f63c0540b088350.svg";